(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5fy9m", function(module, exports) {

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");
"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game() {
        var board = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        (0, $bB0zn._)(this, Game);
        /**
   * Creates a new game instance.
   *
   * @param {number[][]} initialState
   * The initial state of the board.
   * @default
   * [[0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0],
   *  [0, 0, 0, 0]]
   *
   * If passed, the board will be initialized with the provided
   * initial state.
   */ (0, $hD5pT._)(this, "status", "idle");
        (0, $hD5pT._)(this, "score", 0);
        this.board = board;
    }
    (0, $6QEWP._)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.getStatus() !== "playing") return;
                var moved = this.processLeftMoveWithoutRendering();
                if (moved) this.addRandomTile();
                this.updateStatus();
            }
        },
        {
            key: "processLeftMoveWithoutRendering",
            value: function processLeftMoveWithoutRendering() {
                var moved = false;
                for(var row = 0; row < 4; row++){
                    var originalRow = (0, $2Xzd1._)(this.board[row]);
                    var newRow = this.mergeRowByPriority(originalRow);
                    if (!this.arraysEqual(originalRow, newRow)) {
                        moved = true;
                        this.board[row] = newRow;
                    }
                }
                return moved;
            }
        },
        {
            key: "mergeRowByPriority",
            value: function mergeRowByPriority(row) {
                var tiles = row.filter(function(val) {
                    return val !== 0;
                });
                for(var i = 0; i < tiles.length - 1; i++)if (tiles[i] === tiles[i + 1]) {
                    tiles[i] *= 2;
                    this.score += tiles[i];
                    tiles[i + 1] = 0;
                    i++;
                }
                tiles = tiles.filter(function(val) {
                    return val !== 0;
                });
                while(tiles.length < 4)tiles.push(0);
                return tiles.slice(0, 4);
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.getStatus() !== "playing") return;
                this.reverseRows();
                var moved = this.processLeftMoveWithoutRendering();
                this.reverseRows();
                if (moved) this.addRandomTile();
                this.updateStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.getStatus() !== "playing") return;
                this.board = this.transpose(this.board);
                var moved = this.processLeftMoveWithoutRendering();
                this.board = this.transpose(this.board);
                if (moved) this.addRandomTile();
                this.updateStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.getStatus() !== "playing") return;
                this.board = this.transpose(this.board);
                this.reverseRows();
                var moved = this.processLeftMoveWithoutRendering();
                this.reverseRows();
                this.board = this.transpose(this.board);
                if (moved) this.addRandomTile();
                this.updateStatus();
            }
        },
        {
            /**
   * @returns {number}
   */ key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            /**
   * @returns {number[][]}
   */ key: "getState",
            value: function getState() {
                return this.board.map(function(row) {
                    return (0, $2Xzd1._)(row);
                });
            }
        },
        {
            /**
   * Returns the current game status.
   *
   * @returns {string} One of: 'idle', 'playing', 'win', 'lose'
   *
   * `idle` - the game has not started yet (the initial state);
   * `playing` - the game is in progress;
   * `win` - the game is won;
   * `lose` - the game is lost
   */ key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                for(var row = 0; row < 4; row++){
                    for(var col = 0; col < 4; col++)if (this.board[row][col] === 2048) {
                        this.status = "win";
                        return;
                    }
                }
                if (this.canMakeMove()) this.status = "playing";
                else this.status = "lose";
            }
        },
        {
            /**
   * Starts the game.
   */ key: "start",
            value: function start() {
                this.status = "playing";
                var getRandomPosition = function() {
                    var row = Math.floor(Math.random() * 4);
                    var col = Math.floor(Math.random() * 4);
                    return [
                        row,
                        col
                    ];
                };
                var getRandomValue = function() {
                    return Math.random() < 0.1 ? 4 : 2;
                };
                var _getRandomPosition = (0, $kB67t._)(getRandomPosition(), 2), row1 = _getRandomPosition[0], col1 = _getRandomPosition[1];
                this.board[row1][col1] = getRandomValue();
                var row2, col2;
                var ref;
                do ref = (0, $kB67t._)(getRandomPosition(), 2), row2 = ref[0], col2 = ref[1], ref;
                while (row2 === row1 && col2 === col1);
                this.board[row2][col2] = 2;
                this.updateStatus();
            }
        },
        {
            /**
   * Resets the game.
   */ key: "restart",
            value: function restart() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++)this.board[i][j] = 0;
                this.status = "idle";
                this.score = 0;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var i = 0; i < 4; i++){
                    for(var j = 0; j < 4; j++)if (this.board[i][j] === 0) emptyCells.push([
                        i,
                        j
                    ]);
                }
                if (emptyCells.length === 0) return;
                var _emptyCells_Math_floor = (0, $kB67t._)(emptyCells[Math.floor(Math.random() * emptyCells.length)], 2), row = _emptyCells_Math_floor[0], col = _emptyCells_Math_floor[1];
                var value = Math.random() < 0.1 ? 4 : 2;
                this.board[row][col] = value;
            }
        },
        {
            key: "canMakeMove",
            value: function canMakeMove() {
                for(var i = 0; i < 4; i++)for(var j = 0; j < 4; j++){
                    if (this.board[i][j] === 0) return true;
                    if (j < 3 && this.board[i][j] === this.board[i][j + 1]) return true;
                    if (i < 3 && this.board[i][j] === this.board[i + 1][j]) return true;
                }
                return false;
            }
        },
        {
            key: "reverseRows",
            value: function reverseRows() {
                for(var i = 0; i < 4; i++)this.board[i].reverse();
            }
        },
        {
            key: "transpose",
            value: function transpose(matrix) {
                return matrix[0].map(function(_, colIndex) {
                    return matrix.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "arraysEqual",
            value: function arraysEqual(a, b) {
                return a.length === b.length && a.every(function(val, i) {
                    return val === b[i];
                });
            }
        }
    ]);
    return Game;
}();
module.exports = $3d28d7f1aac198f5$var$Game;

});
parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hD5pT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd5a47cf8ef6d766$export$71511d61b312f219; });
function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});

parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



"use strict";

// Uncomment the next lines to use your game instance in the browser
document.addEventListener("DOMContentLoaded", function() {
    var Game = (parcelRequire("5fy9m"));
    var game = new Game();
    var button = document.querySelector(".button");
    var gameScore = document.querySelector(".game-score");
    var startMessage = document.querySelector(".message-start");
    var winMessage = document.querySelector(".message-win");
    var loseMessage = document.querySelector(".message-lose");
    button.addEventListener("click", function() {
        if (button.classList.contains("start")) {
            button.classList.remove("start");
            button.classList.add("restart");
            button.textContent = "Restart";
            game.start();
            $197cd56b15c33885$var$renderBoard(game.getState());
            document.addEventListener("keydown", function(e) {
                var keyName = e.key;
                if (game.getStatus() === "lose") {
                    loseMessage.classList.remove("hidden");
                    return;
                }
                if (game.getStatus() === "win") {
                    winMessage.classList.remove("hidden");
                    return;
                }
                if (keyName === "ArrowRight") {
                    game.moveRight();
                    $197cd56b15c33885$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowLeft") {
                    game.moveLeft();
                    $197cd56b15c33885$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowUp") {
                    game.moveUp();
                    $197cd56b15c33885$var$renderBoard(game.getState());
                }
                if (keyName === "ArrowDown") {
                    game.moveDown();
                    $197cd56b15c33885$var$renderBoard(game.getState());
                }
                gameScore.textContent = game.getScore();
                if (game.getStatus() === "win") winMessage.classList.remove("hidden");
                else if (game.getStatus() === "lose") loseMessage.classList.remove("hidden");
            });
            if (button.classList.contains("restart") && startMessage) startMessage.classList.add("hidden");
        } else {
            button.classList.remove("restart");
            button.classList.add("start");
            button.textContent = "Start";
            if (!winMessage.classList.contains("hidden")) winMessage.classList.add("hidden");
            if (!loseMessage.classList.contains("hidden")) loseMessage.classList.add("hidden");
            gameScore.textContent = game.getScore();
            game.restart();
            $197cd56b15c33885$var$renderBoard(game.getState());
            if (button.classList.contains("start") && startMessage) startMessage.classList.remove("hidden");
        }
    });
});
function $197cd56b15c33885$var$renderBoard(state) {
    var _loop = function(i) {
        var _loop = function(j) {
            cells[j].textContent = state[i][j] === 0 ? "" : state[i][j];
            cells[j].classList.forEach(function(cl) {
                if (cl.startsWith("field-cell--")) cells[j].classList.remove(cl);
            });
            if (state[i][j] !== 0) cells[j].classList.add("field-cell--".concat(state[i][j]));
        };
        var cells = rows[i].querySelectorAll("td");
        for(var j = 0; j < 4; j++)_loop(j);
    };
    var rows = document.querySelectorAll(".game-field tbody tr");
    for(var i = 0; i < 4; i++)_loop(i);
}

})();
//# sourceMappingURL=index.844bdc1a.js.map
